import Http from '../index.js'
import Model from '../Model.js'

class Contacts extends Model {
  constructor() {
    super('/contacts/')
  }

  list(query = '') {
    return Http.get(`${this.model}list_contacts/${query}`)
  }

  create(payload) {
    return Http.post(`${this.model}create_contact/`, {
      ...payload,
    })
  }

  createDependent(payload) {
    return Http.post(`${this.model}create_dependent/`, payload)
  }

  getBankAccounts(id) {
    return Http.get(`${this.model}${id}/contact_transfer_destinations/`)
  }

  read(id) {
    return Http.get(`${this.model}${id}/contact_info/`)
  }

  update(payload) {
    return Http.post(`${this.model}update_contact/`, {
      ...payload,
    })
  }

  createBankOrAddress(payload) {
    return Http.post(`${this.model}create_address_or_bank_account_for_contact/`, {
      ...payload,
    })
  }

  makeBankAccountPrimaryForContact(payload) {
    return Http.post(`${this.model}make_bank_account_primary_for_contact/`, payload)
  }

  importFromCsv(file) {
    return Http.post(`${this.model}import_contacts_from_csv/`, file)
  }

  contactsLot(payload) {
    return Http.post(`${this.model}create_contact_lot/`, payload)
  }

  delete(payload) {
    return Http.post(`${this.model}delete_contact/`, payload)
  }

  updateContactStatus(id, active) {
    return Http.post(`${this.model}${id}/update_contact_status/`, { active })
  }
}

export default new Contacts()
